const MM_TO_PT = 72 / 25.4;

/**
 * Typical printable width on 80mm paper (~4mm unprintable each side).
 * Use this as the PDF page width so print preview fits at 100% /
 * Actual size. "Fit to printable area" is not needed and would blur.
 */
const THERMAL_PAGE_WIDTH_MM = 72;
export const THERMAL_PAGE_WIDTH_PT =
  Math.round(THERMAL_PAGE_WIDTH_MM * MM_TO_PT * 100) / 100;
